<template>
    <div class="page">
        <div class="menu-wrap">
            <div class="menu-item" @click="goto('tc')"></div>
            <div class="menu-item" @click="goto('qa')"></div>
            <div class="menu-item" @click="goto('info')"></div>
            <div class="menu-item" @click="unsub"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Setting',
    data(){
        return {
            id: '',
            name: '',
            mobile: '',
            score: 0,
            ranking: 0,
            list: [],

            showSharePop: false,
            shareUrl: 'http://qs.wobangta.com/#/share',
            shareTitle: '',
            shareDesc: '',
            questionId: this.$route.query.id
        }
    },
    computed: {
        ...mapState(['userInfo','lang','langMap'])
    },
    created(){

    },
    methods: {
        goto(page){
            this.$router.push(page);
        },
        unsub(){
            let msg = 'အဖွဲ့ဝင်အဖြစ်မှ နှုတ်ထွက်ရန် သေချာပြီလား?';
            this.$dialog.confirm({
                message: msg,
                confirmButtonText: 'yes',
                cancelButtonText: 'no'
            }).then(action=>{
                if(action === 'confirm'){
                    this.requestUnsub();
                    localStorage.clear();
                    this.$router.push('land');
                }
            })
        },
        requestUnsub(){
          Utils.$ajax({
            type: 'post',
            url: '/user/unsub',
            data: {},
          }).done(res=>{

          })
        }
    }
}
</script>

<style lang="scss" scoped>
    .menu-wrap{
        display: flex;
        width: rem(728);
        height: rem(538);
        margin:rem(240) auto 0;
        background: url('~@/assets/menu-1.png') center center/contain no-repeat;
        justify-content: space-between;
        flex-wrap: wrap;
        .menu-item{
            width: rem(363);
            height: rem(228);
            margin-bottom: rem(70);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Setting.vue